import Constants from './constants';

export default {
    INVALID_IDENTIFIER : "Invalid ",
    INVALID_TXN_TYPE : "Select a Tran. Group",
    INVALID_START_DATE : "Invalid Start Date",
    INVALID_END_DATE : "Invalid End Date",
    INVALID_DATE_RANGE : `Invalid date range. Max. of ${Constants.MAX_DATE_RANGE_MONTHS} month(s).` ,
    INVALID_REQUESTED_AMOUNT : "Invalid Requested Amount",
    INVALID_REASON_CODE : "Invalid Reason Code",
    INVALID_DISPENSE_TYPE : "Invalid Dispense Type",
    INVALID_DISPUTE_CATEGORY : "Invalid Dispute Category",
    INVALID_CODE :  "Invalid Code",
    INVALID_CODES :  "Invalid Codes",
    INVALID_NAME :  "Invalid Name",
    INVALID_CHANNEL :  "Select a Channel",
    INVALID_STORE :  "Invalid Store",
    INVALID_CUSTOMER_REFERENCE_FIELD :  "Invalid Customer Reference Parameter",


    ERROR_TRANSACTIONS_SEARCH : "Error fetching transactions",
    ERROR_TRANSACTIONS_SEARCH_TITLE : "Could not get Transactions",

    ERROR_TRANSACTION_FETCH : "Error fetching transaction",

    ERROR_TRANSACTION_GROUPS : "Could not fetch transaction groups",
    ERROR_TRANSACTION_TYPES : "Could not fetch transaction types",
    ERROR_TRANSACTION_STORES : "Could not fetch transaction stores",

    ERROR_DISPUTES_SEARCH : "Error fetching disputes",
    ERROR_DISPUTES_SEARCH_TITLE : "Could not get disputes",
    ERROR_DISPUTE_TRANSACTION_FETCH : "Error fetching transaction",

   
    ERROR_DISPUTE_FETCH_TITLE : "Could not get dispute",
    ERROR_DISPUTE_REGION : "Could not get dispute regions",
    ERROR_DISPUTE_CATEGORIES : "Could not get dispute categories",
    ERROR_DISPUTE_SETTLEMENTS_TITLE : "Could not get settlements",

    ERROR_REASON_CODES : "Could not get reason codes",
    ERROR_TRANSACTION_TIMELINES :"Could not get transaction timelines",
    ERROR_MERCHANT_DISPUTANTS : "Could not get merchant disputants",

    SUCCESS_DISPUTE_CREATION : "Dispute successfuly created",
    ERROR_DISPUTE_CREATION : "Error Creating dispute",
    
    SUCCESS_DISPUTE_ACTION : "Action Successful",
    ERROR_DISPUTE_ACTION : "Could not perform Action",
    SUCCESS_TRANSACTION_TIMELINE_DELETE : "Transaction Timeline  successfully  deleted",
    SUCCESS_MERCHANT_DISPUTANT_CREATED : "Merchant Disputant  successfully  created",
    SUCCESS_MERCHANT_DISPUTANT_DELETE : "Merchant Disputant  successfully  deleted",
    
    SUCCESS_DISPUTE_BATCH_UPLOAD : "Batch uploaded successfully",
    ERROR_DISPUTE_BATCH_UPLOAD : "Error uploading batch file",

    ERROR_SCRIPT_UPDATE: "Error updating script",
    
    ERROR_REASON_CODE_UPDATE: "Error creating/updating reason code",
    ERROR_TRANSACTION_TYPE_UPDATE: "Error creating/updating transaction type",
    ERROR_TRANSACTION_TIMELINES_UPDATE: "Error creating/updating timelines",
    ERROR_TRANSACTION_TIMELINES_DELETE: "Error deleting transaction timelines",
    ERROR_MERCHANT_DISPUTANT_CREATE : "Error creating merchant disputant",
    ERROR_MERCHANT_DISPUTANT_DELETE : "Error deleting merchant disputant",

    
    ERROR_DISPUTE_REGION_UPDATE: "Error creating/updating dispute region",
    ERROR_TRANSACTION_GROUP_UPDATE : "Error creating/updating transaction group",
    

    ERROR_SCRIPTS:"Error fetching scripts",

    ERROR_FILE_TOO_LARGE_TITLE :"Too Large",
    ERROR_FILE_TOO_LARGE : "Selected file too large. Maximum file size is ",

    ERROR_EVIDENCE_ADD : "Could not add evidence ",

    ERROR_MAXIMUM_EVIDENCE_UPLOAD_COUNT : "Maximum number of evidence files exceeded",
    ERROR_EVIDENCE_INVALID_FILE_TYPE_TITLE: "Bad file format",

    ERROR_EVIDENCE_INVALID_FILE_TYPE: "Unsupported file format. Only JPEG and PNG formats are supported ",
    ERROR_EVIDENCE_NO_FILE_SELECTED: "No files selected",
    ERROR_EVIDENCE_REQUIRED : "Evidence required to perform action on Dispute. Please attach evidence.",
    ERROR_COMMENT_REQUIRED : "Comment required to perform action on Dispute. Please add a comment.",

    ERROR_BATCH_INVALID_FILE_TYPE_TITLE: "Bad file format",
    ERROR_BATCH_INVALID_FILE_TYPE: "Unsupported file format. Only Excel Workbooks(.xls and .xlsx) formats are supported ",
    ERROR_BATCH_NO_FILE_SELECTED: "No files selected",



    ACTION_NEVER_ASK : "Never ask for this action again.",
    ACTION_WARNING : "Are you sure you want to perform the action",

    NO_PERMISSIONS : "You don't have permissions on this app.",
    LOAD_PERMISSIONS_ERROR : "Error loading user permissions",

    SESSION_TIMEOUT : "Session timed out. Redirecting to login page"

    
};


// WEBPACK FOOTER //
// ./src/configurations/messages.js